export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
  EMAIL: 'email',
  OUTBOUND_CALLING: 'outbound_calling',
};
